module.exports = __webpack_public_path__ + "img/img-a310d044.da183c65.png";